export const GCP_PROJECT_ID_VALIDATION = {
  message:
    '6-30 chars, start with a letter, use letters/digits/hyphens, and not end with a hyphen',
  // Example valid: my-proj-123
  regex: /^[A-Z][A-Z0-9-]{4,28}[A-Z0-9]$/i
}

export const GCP_PROJECT_ID_DUPLICATION = {
  message: 'Cannot be an existing Project ID',
  // Checks against existing integrationIds (uppercased by consumer)
  test: (value: string | undefined, integrationIdsUppercase: Set<string>) =>
    !value ||
    integrationIdsUppercase.size === 0 ||
    !integrationIdsUppercase.has(value.toUpperCase())
}

/* TODO: add service account id field utils */
